import React from "react";
import Layout from "../../components/layout/parentLayout/Layout";
import "./talentContest.css";

function TalentContestPage() {
	return (
		<Layout>
			<div className="container bestwriterandseller-wrapper-container mt-5 p-4">
				<div className="text-center fw-bold guidline-headings ">
					Show Me Your Emoji!
				</div>
				<h3 className="text-center mb-3 fw-normal">Talent Contest</h3>
				<p className="text-center fw-bold">
					<span style={{ fontSize: "2rem" }}>🎭🧑‍🎤🎸</span>
				</p>

				<p className="text-center" style={{ fontSize: "2rem" }}>
					COMING SOON!
				</p>
			</div>
			{/* <div className="container">
					<p className="coming-soon-center fw-bold">
						COMING SOON!&nbsp;{" "}
						<span style={{ fontSize: "3.5rem" }}>🎭🧑‍🎤🎸</span>
					</p>
				</div>
			</div> */}
		</Layout>
	);
}

export default TalentContestPage;
